// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VsFB","textarea":"styles_textarea__1VD2o"};